export default "__VITE_ASSET__Dvmi31I2__"